import {appConfig} from 'src/shared/config'
import {getPassportRetpath} from 'src/shared/utils'

/**
 * функция getPassportUrl из appConfig для BDUI подменяется,
 * чтобы после возвращения из паспорта заполненная форма не слетала из-за сеошных координат в retpath
 */
export function getPassportUrl(path: string) {
  const address = appConfig.getPassportUrl(path)

  const url = new URL(address)
  url.searchParams.set('retpath', getPassportRetpath(window.location.href))

  return url.toString()
}
